import styles from './division.module.scss';

interface DivisionProps {
  operandOne: React.ReactNode;
  operandTwo: React.ReactNode;
}

export const Division = ({ operandOne, operandTwo }: DivisionProps) => {
  return (
    <div className={styles.division}>
      <div className={styles.operand}>{operandOne}</div>
      <div className={styles.divider} />
      <div className={styles.operand}>{operandTwo}</div>
    </div>
  );
};
